import { CameraAlt, UploadFile } from '@mui/icons-material';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import React from 'react';

import { BottomSheet } from '../../../../../components/molecules/BottomSheet';

interface MobileMoreMenuSheetProps {
  open: boolean;
  onClose: () => void;
  onTakePhoto: () => void;
  onUploadFiles: () => void;
}

export const MobileMoreMenuSheet: React.FC<MobileMoreMenuSheetProps> = ({
  open,
  onClose,
  onTakePhoto,
  onUploadFiles,
}) => {
  const handleTakePhoto = (): void => {
    onClose();
    onTakePhoto();
  };

  const handleUploadFiles = (): void => {
    onClose();
    onUploadFiles();
  };

  return (
    <BottomSheet open={open} onClose={onClose} height="small" title="More Options">
      <List disablePadding>
        <ListItemButton onClick={handleTakePhoto}>
          <ListItemIcon>
            <CameraAlt />
          </ListItemIcon>
          <ListItemText primary="Take Photo" />
        </ListItemButton>
        <ListItemButton onClick={handleUploadFiles}>
          <ListItemIcon>
            <UploadFile />
          </ListItemIcon>
          <ListItemText primary="Upload Files" />
        </ListItemButton>
      </List>
    </BottomSheet>
  );
};
